import React from 'react';

import { type EmailMessagesFilterInput } from '@dashboard/generated/wp/platform';
import { SearchOutlined } from '@mui/icons-material';
import { IconButton, Menu } from '@mui/material';

import SearchForm from './SearchForm';

type Props = {
  filter: EmailMessagesFilterInput;
  setFilter: (value: EmailMessagesFilterInput) => void;
};
export default function SearchInput({ filter, setFilter }: Props) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  let menu = null;
  if (anchorEl) {
    menu = <SearchForm filter={filter} setFilter={setFilter} setAnchorEl={setAnchorEl} />;
  }

  return (
    <>
      <IconButton size="small" edge="start" onClick={handleClick}>
        <SearchOutlined />
      </IconButton>
      <Menu
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        MenuListProps={{ sx: { p: 1 } }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {menu}
      </Menu>
    </>
  );
}
